/* src/app/shared/components/ag-search-bar/ag-search-bar.component.scss */
.search-container {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  padding: 8px 16px;
  background-color: #f2f2f2;
  min-height: 48px;
  width: 314px;
}
.search-container-focused {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  padding: 8px 16px;
  background-color: #ffffff;
  border: 1px solid #dfdfdf;
  min-height: 48px;
  width: 314px;
  cursor: text;
}
.small-search-container {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  padding: 8px 16px;
  background-color: #f2f2f2;
  min-height: 40px;
  width: 314px;
}
.small-search-container-focused {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  padding: 8px 16px;
  background-color: #ffffff;
  border: 1px solid #dfdfdf;
  min-height: 40px;
  width: 314px;
  cursor: text;
}
.input {
  height: 26px;
  width: 100%;
  float: right;
  font-size: 14px;
  border: none;
  outline: none;
  background-color: #f2f2f2;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #222222;
}
.input-focused {
  height: 26px;
  width: 100%;
  float: right;
  font-size: 14px;
  border: none;
  outline: none;
  background-color: #ffffff;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #222222;
}
.ag-value {
  position: relative;
  height: 24px;
  display: flex;
  cursor: text;
  width: 100%;
}
.ag-value .label {
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #5c5c5c;
  position: absolute;
  z-index: 2;
  cursor: text;
  transition: transform 0.2s ease-out, font-size 0.2s ease-out;
}
.ag-value .input {
  height: 26px;
  width: 100%;
  float: right;
  font-size: 14px;
  border: none;
  outline: none;
  background-color: #f2f2f2;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #222222;
}
.ag-value .input::placeholder {
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  color: #5c5c5c;
}
.ag-value .input-focused {
  height: 26px;
  width: 100%;
  float: right;
  font-size: 14px;
  border: none;
  outline: none;
  background-color: #ffffff;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #222222;
}
.ag-value .label.above {
  transform: translateY(-10px);
  font-size: 12px;
}
.search-img {
  height: 20px;
  width: 20x;
}
.cross-img {
  height: 20px;
  width: 20x;
  cursor: pointer;
}
/*# sourceMappingURL=ag-search-bar.component.css.map */
